import React from 'react'

import { DataGridConfigProvider } from '@cbgms/components/list/DataGridConfigProvider'
import { IFilterConfig } from '@cbgms/api/modules/concept-app/model'

import useGmsEnums from 'contexts/Enums/useGmsEnums'

interface Props {
  filters?: IFilterConfig[]
}

export function GMSDataGridConfigProvider({ children }: React.PropsWithChildren<{}>) {
  const enums = useGmsEnums()

  return <DataGridConfigProvider valueOptionsLookupTable={enums.data || {}}>{children}</DataGridConfigProvider>
}

export function GMSDataGridConfigProviderWithFilter({ children, filters }: React.PropsWithChildren<Props>) {
  const enums = useGmsEnums()

  const filteredData = { ...enums.data }
  if (filters) {
    filters.forEach(({ enumKey, filterKeys }) => {
      if (enumKey && filterKeys) {
        filteredData[enumKey] = (filteredData[enumKey] || []).filter((item: string) => !filterKeys.includes(item))
      }
    })
  }

  return <DataGridConfigProvider valueOptionsLookupTable={filteredData}>{children}</DataGridConfigProvider>
}
